import { z } from 'zod';
const norm = z.number().min(0).max(1);
const ts = z.number().int().nonnegative();
const MouseMove = z.object({
    kind: z.literal('move'),
    x: norm,
    y: norm,
    buttons: z.number().int().nonnegative(),
    ts,
});
const MouseButton = z.object({
    kind: z.literal('button'),
    x: norm,
    y: norm,
    button: z.number().int().min(0).max(4),
    down: z.boolean(),
    ts,
});
const MouseWheel = z.object({
    kind: z.literal('wheel'),
    deltaX: z.number(),
    deltaY: z.number(),
    ts,
});
export const MouseEvent = z.discriminatedUnion('kind', [MouseMove, MouseButton, MouseWheel]);
export const KeyEvent = z.object({
    keyCode: z.string().min(1),
    down: z.boolean(),
    modifiers: z.number().int().nonnegative(),
    ts,
});
//# sourceMappingURL=input.js.map